"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateProvider = void 0;
exports.RateProvider = {
    DAT: 'DAT',
    DELIVERR: 'DELIVERR',
    GTZ: 'GTZ',
    P44: 'P44',
    SHIPWELL: 'SHIPWELL',
    DELIVERR_CSP: 'DELIVERR_CSP'
};
//# sourceMappingURL=rate-provider.js.map